<template>
  <div class="signup-page">
    <div class="signup-page__wrapper">
      <template v-if="!isRegister">
        <div class="signup-page__header">
          <h2 class="small-title title">Please Sign up to continue</h2>
          <p class="description">The page you are trying to visit requires to using your account.</p>
        </div>
        <div class="signup-page__mediasocial">
          <button class="btn-block facebook subhead not-rounded" @click="socialLogin(`facebook`, currentRoute)">
            <i class="adx-ic_facebook"></i>
            Continue with Faceboook
          </button>
          <button class="btn-block secondary google subhead not-rounded" @click="socialLogin(`google`, currentRoute)">
            <i class="adx-ic_google"></i>
            Continue with Google
          </button>
        </div>
        <div class="signup-page__divider">
          <span></span>
          <div class="or">OR</div>
          <span></span>
        </div>
        <div class="signup-page__input">
          <button @click="toggleSignup" class="btn-block primary signin not-rounded">Sign up with Email</button>
        </div>
        <div class="signup-page__footer">
          <div class="signup subhead">
            Already have an account ? <span class="subhead" @click.stop="goToSignin">Sign in</span>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="signup-page__header">
          <h2 class="small-title title">Sign up</h2>
          <div class="socialmedia">
            Continue with <span class="color-pink" @click="socialLogin(`facebook`, currentRoute)">Facebook</span> or <span class="color-pink" @click="socialLogin(`google`, currentRoute)">Google</span>
          </div>
        </div>
        <div class="signup-page__input">
          <adx-form
            @complete="complete"
            :schema="schema"
            :model.sync="model"
            :error.sync="error"
            :onSubmit="onSubmit"
            :wrapper="wrapper" />
        </div>
        <div class="signup-page__footer">
          <div class="signup subhead">
            Already have an account ? <span class="subhead" @click.stop="goToSignin">Sign in</span>
          </div>
        </div>
      </template>

    </div>
  </div>
</template>

<script>
import FormAbstraction from '@/components/Form'

import api from '@/api'
import types from '@/lib/types'
import { apiV2 } from '@/api/urls'
import { authMixin } from '@/lib/mixins/authMixin'

const {
  ButtonType: { BUTTON, RESET },
  ButtonAction: { SUBMIT, APICALL, GOTO }
} = types

export default {
  name: 'adx-signup-page',
  components: {
    'adx-form': FormAbstraction
  },
  mixins: [ authMixin ],
  props: {

  },
  data() {
    return {
      isRegister: false,
      wrapper: {
        alertWrapper: `content`
      },
      model: {
        email: ``,
        fullname: ``,
        mobile: ``,
        company: ``,
        password: ``,
        agree: ``
      },
      error: {

      },
      onSubmit: {
        wrapper: {
          class: ``
        },
        buttons: [
          {
            type: BUTTON,
            action: SUBMIT,
            label: `Register`,
            uri: apiV2.signup,
            params: this.model,
            method: `post`, // HTTP Method
            class: `btn-block primary signin not-rounded`,
            isLoading: false
          },
        ]
      },
      schema: [
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Email Address *',
              model: 'email',
              method: 'onChange',
              validation: ['NotEmpty', 'Email']
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Full Name *',
              model: 'fullname',
              method: 'onChange',
              validation: ['NotEmpty', 'MaxLength:100']
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Phone Number *',
              model: 'mobile',
              method: 'onChange',
              validation: ['NotEmpty', 'Phone', 'MaxLength:16']
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Company Name',
              model: 'company'
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'password',
              label: 'Create Password *',
              model: 'password',
              method: 'onChange',
              validation: ['NotEmpty']
            }
          ]
        },
        {
          type: 'flex',
          fields: [
            {
              type: 'checkbox',
              label: 'I Agree',
              model: 'tnc',
              validation: ['Checked']
            },
            {
              type: 'link',
              label: 'Terms of service',
              to: 'terms-of-service',
              others: '_blank'
            }
          ]
        },
      ]
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    complete($event) {
      (async () => {

        const { redirect_to } = $event.args.data

        this.$router.push(redirect_to)

        this.toggleModal()
      })();
    },
    toggleSignup() {
      this.isRegister = !this.isRegister
    },
    goToSignin() {
      this.$router.push({name: 'signin'})
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>